import {
    Component, OnInit,
    ChangeDetectorRef,
    EventEmitter, Output
} from '@angular/core';

import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

import { UserService } from '../services/user.service';
import { HttpClient } from '@angular/common/http';

import { FirestoreService } from '../services/firestore.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { StripeService } from '../services/stripe.service';
import { take, tap } from 'rxjs/operators';
import { Constants } from 'src/app/shared/constants';
import { Attendee } from '../Models/Attendee';



@Component({
    selector: 'app-review-page',
    templateUrl: './review-page.component.html',


})

export class ReviewPageComponent implements OnInit {
    @Output() completed = new EventEmitter<string>();

    // Backend URLs
    stripePaymentLink: string = 'https://buy.stripe.com/00wbJ053s82R84O4wqbjW0k';// early registration link
    stripePaymentLinkProd: string = 'https://buy.stripe.com/dRmdR87bAerfbh01kebjW0m'; // main link
    stripePaymentLinkTest: string = 'https://buy.stripe.com/test_00g7uO2zf5GSh1K3cc'; // CVCF Registration 2025 All Days TEST
    stripePaymentLinkOneDay: string = 'https://buy.stripe.com/6oUbJ0cvU3MBcl4e70bjW0p'; //  CVCF Registration 2025 One Day
    stripePaymentLinkTwoDay: string = 'https://buy.stripe.com/6oUaEWcvU4QFacW8MGbjW0q';  // CVCF Registration 2025 Two Day
    // StripeWinterRetreatLink: string = 'https://buy.stripe.com/9B64gy67w0Ap2KubYSbjW0l';  // CVCF Winter Retreat link 
   
    stripePaymentLinkOneDayShirt: string = 'https://buy.stripe.com/5kQ14mfI64QFdp89QKbjW0r';
    stripePaymentLinkTwoDayShirt: string = 'https://buy.stripe.com/3cI3cugMagznbh06EybjW0s';
    stripePaymentLinkFullShirt: string = 'https://buy.stripe.com/bJe3cu53s96Vetc4wqbjW0n';
    stripePaymentLinkShirtOnly: string = 'https://buy.stripe.com/8x28wO67waaZetc0gabjW0o';
    // Generic variables
    registers: any;
    email = '';
    discount: string;
    chargeId: string;
    receiptUrl: string;

    // Cost calculation variables
    total_cost = 0;

    // Submit button disabled
    button_disabled = false;

    // Generic data object for incoming value from webtask.io
    dataObj: any;
    paymenthandler: any = null;

    constructor(private cd: ChangeDetectorRef, private userService: UserService,
        private http: HttpClient,
        private router: Router,
        private fs: FirestoreService,
        private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private stripeService: StripeService) { }

    ngOnInit() {
        // Get data from form registrations
        this.registers = this.userService.getAllRegisters();

        // Scrolls to top of screen
        window.scrollTo(0, 0);

        // Calculates total for registers
        this.registers.forEach(attendee => {
            this.total_cost += attendee.cost;
        })

        this.button_disabled = false;
    }

    // The idea of this function is to submit the Attendee information to the database, while also ensuring that the payment has been collection.
    // So, we first submit the information to a Backup DB to hold the information, then confirm whether the payment goes through. If successful, the Attendee
    // information is then posted to the main DB.
    async onSubmit(form: NgForm) {
        // Disable button when submitting form to prevent multiple submissions
        this.button_disabled = true;
        this.spinner.show();

        if (this.registers.length !== 0) {
            // Allows the user to submit without credit card info if cost is 0

            this.postToDatabase(false).then(
                () => {
                    this.postToDatabase(true).then(
                        () => {
                            this.spinner.hide();
                            this.calculateDaysAttending();
                        },
                        (errorToDB) => {
                            console.error('Post to Main Database error', errorToDB);
                            this.spinner.hide();
                            this.toastr.error('There was an error saving your information to the main DB', 'Database Error');
                        }
                    );
                },
                (errorToBackup) => {
                    console.error('Post to Backup Database error', errorToBackup);
                    this.spinner.hide();
                    this.toastr.error('There was an error saving your information to backup DB', 'Database Error');
                }
            );
        }
    }

    // Monitor email value and set it here.
    onKey(value: string) {
        this.email = value;
    }

    // Post list of registers to Firebase connected to Firestore
    postToDatabase(postToMainDB: boolean) {
        let promise: any;

        // Fix cost for all registers
        this.registers.forEach(attendee => {
            attendee.chargeId = this.chargeId;
            attendee.receiptUrl = this.receiptUrl;
            attendee.checked_in = false;
            attendee.time_registered = new Date().toString();
        });

        if (postToMainDB) {
            promise = new Promise((resolve, reject) => {
                this.fs.postAttendees(this.registers)
                    .subscribe(
                        (data) => resolve(data),
                        (err) => {
                            console.log(err);
                        });
            });
        } else {
            promise = new Promise((resolve, reject) => {
                this.fs.postAttendeesToBackup(this.registers)
                    .subscribe(
                        (data) => resolve(data),
                        (err) => {
                            console.log(err);
                        });
            });
        }

        return promise;
    }


    redirectToStripe(): void {
        window.location.href = this.stripePaymentLink;
    }

  calculateDaysAttending() {
    var daysCount = 0;

    if (this.registers[0].days_attending.includes('Thursday')) { daysCount += 0.5; }
    if (this.registers[0].days_attending.includes('Friday')) { daysCount++; }
    if (this.registers[0].days_attending.includes('Saturday')) { daysCount++; }
    if (this.registers[0].days_attending.includes('Sunday')) { daysCount += 0.5; }

    const addedShirt = this.registers[0].add_shirt === true;

   if (daysCount == 0) {
    this.router.navigate(['/', 'thank-you']);
    }
    else if (daysCount <= 0.5 && addedShirt) {
        this.stripePaymentLink = this.stripePaymentLinkShirtOnly;
        this.redirectToStripe();
    }
    else if (daysCount <= 0.5 && !addedShirt) {
        this.router.navigate(['/', 'thank-you']);
    }
    else if (daysCount <= 1 && addedShirt) {
        this.stripePaymentLink = this.stripePaymentLinkOneDayShirt;
        this.redirectToStripe();
    }
    else if (daysCount <= 1 && !addedShirt) {
        this.stripePaymentLink = this.stripePaymentLinkOneDay;
        this.redirectToStripe();
    }
    else if ((daysCount == 1.5 || daysCount == 2) && addedShirt) {
        this.stripePaymentLink = this.stripePaymentLinkTwoDayShirt;
        this.redirectToStripe();
    }
    else if ((daysCount == 1.5 || daysCount == 2) && !addedShirt) {
        this.stripePaymentLink = this.stripePaymentLinkTwoDay;
        this.redirectToStripe();
    }
    else if (daysCount > 2 && addedShirt) {
        this.stripePaymentLink = this.stripePaymentLinkFullShirt;
        this.redirectToStripe();
    }
    else if (daysCount > 2 && !addedShirt) {
        this.stripePaymentLink = this.stripePaymentLinkProd;
        this.redirectToStripe();
    }
    }
}